import { gql } from "@apollo/client";

export const ACCOUNT_ROLES_QUERY = gql`
  query GetAccountRoles {
    account {
      id
      email
      merchantAccounts {
        roles
        merchant {
          identifier
          name
        }
      }
    }
  }
`;
